import { FC, useRef, useState } from 'react';
import { Typography, ButtonBase, Input, InputProps } from 'material-hu';
import { grey } from '@mui/material/colors';
import { getAttachment } from 'src/utils/files';
import { FileTypes, Attachment } from 'src/types/attachments';

export type FormImageProps = InputProps & {
  icon: any;
  baseColor?: string;
  label?: string;
  defaultImage?: Attachment;
  onChange: (file) => void;
};

const FormImage: FC<FormImageProps> = props => {
  const {
    name,
    icon,
    baseColor = grey[400],
    label = '',
    defaultImage = null,
    onChange,
    ...others
  } = props;

  const [image, setImage] = useState<Attachment | null>(defaultImage);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleAttach = (): void => {
    fileInputRef.current.click();
  };

  const handleChange = async event => {
    const file = event.target.files[0];

    const newFile = {
      name: file.name,
      size: file.size,
      mime: file.type,
      fileObject: file,
      type: FileTypes.IMAGE,
    };

    setImage(getAttachment(newFile));
    onChange(newFile);
  };

  const inputSx = others.sx || {};

  return (
    <>
      <ButtonBase
        onClick={handleAttach}
        focusRipple
        sx={{
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          backgroundColor: baseColor,
          '&:hover': {
            '& .MuiTypography-root': {
              opacity: 1,
            },
          },
          '& .MuiTypography-root': {
            color: 'white',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            position: 'absolute',
            opacity: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1rem',
            backgroundColor: `${grey[600]}be`,
          },
          '& .image': {
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover',
          },
        }}
      >
        {!image ? (
          icon
        ) : (
          <img
            className="image"
            src={image.url}
            alt=""
          />
        )}
        <Typography variant="button">{label}</Typography>
      </ButtonBase>
      <Input
        {...others}
        type="file"
        inputProps={{
          accept: 'image/png, image/jpg, image/jpeg',
        }}
        sx={{
          display: 'none',
          ...inputSx,
        }}
        inputRef={fileInputRef}
        onChange={handleChange}
      />
    </>
  );
};

export default FormImage;
